import React from "react"
import { Link } from "gatsby"

const FooterLinks = ({ list }) => {
  return (
    <>
      {list.map((link, index) => {
        return link.isExternal ? (
          <a
            key={index}
            href={link.link}
            target="_blank"
            rel="noreferrer noopener"
          >
            {link.name}
          </a>
        ) : (
          <Link to={link.link} key={link.name}>
            {link.name}
          </Link>
        )
      })}
    </>
  );
}

export default FooterLinks
